// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 592 ? "common" : chunkId) + "." + {"383":"29281928","541":"adaa0bd1","592":"47d15cf8","734":"dcca1894","877":"aea273f7"}[chunkId] + ".chunk.js";
};